import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../../lib/utils';
import type { PopoverContentProps } from './types';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 0,
      matchTriggerWidth = true,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'eye:bg-popover eye:text-popover-foreground eye:z-[10001]',
          'eye:origin-[--radix-popover-content-transform-origin] eye:rounded-md eye:border',
          'eye:outline-none eye:data-[side=bottom]:slide-in-from-top-2 eye:data-[side=left]:slide-in-from-right-2',
          'eye:data-[side=right]:slide-in-from-left-2 eye:data-[side=top]:slide-in-from-bottom-2',
          'eye:overflow-y-auto eye:data-[state=closed]:animate-out',
          'eye:data-[state=closed]:fade-out-0 eye:data-[state=closed]:zoom-out-95 eye:data-[state=open]:animate-in',
          'eye:data-[state=open]:fade-in-0 eye:data-[state=open]:zoom-in-95',
          'eye:border-grey-20 eye:bg-white eye:py-2xs',
          matchTriggerWidth
            ? 'eye:w-[var(--radix-popover-trigger-width)]'
            : 'eye:w-auto',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose };
